export const hpStations = [
  {
    id: '1',
    address: 'sharon massachusetts',
    company: 'mbta',
    stationTitle: 'sharon',
    segmentTitles: ['outbound platform', 'inbound platform'],
  },
  {
    id: '2',
    address: 'boston massachusetts',
    company: 'mbta',
    stationTitle: 'blue hill',
    segmentTitles: [
      'cummings highway walkway',
      'outbound platform',
      'inbound platform',
      'blue hill avenue walkway',
    ],
  },
];

export const getHpStationName = (station) =>
  `${station.company} - ${station.stationTitle}, ${station.address}`;

export const countHpSegments = () =>
  hpStations.reduce(
    (total, station) => total + station.segmentTitles.length,
    0,
  );
